import { TableCell, TableRow } from '@material-ui/core';
import { Checkbox, IconClickable, Text, View } from 'src/components/common';
import cn from 'classnames';
import { IoIosArrowDown } from 'react-icons/io';
import './styles.scss';
import { DeleteDailyTimesheetByIdPayload } from 'src/redux/timesheet/types';

const rowFiled = ['date', 'startTime', 'endTime', 'regularHours', 'otHours', 'action'];
const jobHeader = ['Job', 'Task', 'Lot#s', 'Hours', 'Phase Code', 'Extra'];
const jobField = ['job', 'task', 'lots', 'hours', 'phaseCode', 'isExtra'];

const lockupLabel = (id: string, options: { id: string; code: string; description?: string; name?: string }[]) => {
  const item = options.find(item => item.id === id);

  return item?.code ?? '--';
};

export const getRowJob = ({ data, handleEditRow, handleShowDetail, onDeleteRow, jobs, tasks, phases }) => {
  const jobList = data?.action?.jobs;
  const handleDeleteRow = ({
    dailyTimesheetId,
    weeklyTimesheetId,
    date,
  }: DeleteDailyTimesheetByIdPayload & { date: string }) => {
    weeklyTimesheetId = weeklyTimesheetId?.split('/')[2];
    onDeleteRow({ dailyTimesheetId, weeklyTimesheetId, date });
  };

  let res = [
    <TableRow className={cn('cmp-rowJob')}>
      <TableCell>
        <IoIosArrowDown
          onClick={() => handleShowDetail(data.index)}
          className={cn('cmp-rowJob__icon', { 'cmp-rowJob__icon--up': data.isShowDetail })}
        />
      </TableCell>
      {rowFiled.map(name =>
        name === 'action' ? (
          <TableCell align="center">
            <IconClickable className="cmp-rowJob__action" name="ic_edit" onClick={() => handleEditRow(data[name])} />
            <IconClickable
              className="cmp-rowJob__action"
              name="ic_trash"
              onClick={() => {
                handleDeleteRow({
                  dailyTimesheetId: data[name]['id'],
                  weeklyTimesheetId: data[name]['auditHistoryUri'],
                  date: data.date,
                });
              }}
            />
          </TableCell>
        ) : (
          <TableCell>{data.isNotWorking && name !== 'date' ? '--' : !!data[name] ? data[name] : '--'}</TableCell>
        ),
      )}
    </TableRow>,
  ];

  if (data.isShowDetail) {
    if (data.isNotWorking) {
      res.push(
        <TableRow>
          <TableCell colSpan={7}>
            <View className={cn('cmp-rowJob__detail')}>
              <Text>This employee didn’t work on this day.</Text>
              <Text>
                Reason:{' '}
                {data.action.comments.includes('Other (provide more info)')
                  ? data.action.commentOther
                  : data.action.comments[0]}
              </Text>
            </View>
          </TableCell>
        </TableRow>,
      );
    } else if (jobList?.length === 1 && !jobList[0].phaseCode) {
      res.push(
        <TableRow>
          <TableCell colSpan={7}>
            <View className={cn('cmp-rowJob__detail')}>
              <Text className={cn('cmp-rowJob__detail--no-records')}>No records.</Text>
            </View>
          </TableCell>
        </TableRow>,
      );
    } else {
      res.push(
        <TableRow>
          <TableCell colSpan={7}>
            <View className={cn('cmp-rowJob__detail')}>
              <table>
                <thead className={cn('cmp-rowJob__detail__header')}>
                  <tr>
                    {jobHeader.map(item => (
                      <th>{item}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {jobList.map(item => (
                    <tr>
                      {jobField.map(field =>
                        field === 'isExtra' ? (
                          <td className={cn('cmp-rowJob__detail__checkbox')}>
                            <Checkbox.Item checked={item[field]} onChange={() => {}} />
                          </td>
                        ) : field === 'job' ? (
                          <td>{lockupLabel(item[field], jobs)}</td>
                        ) : field === 'task' ? (
                          <td>{!!item.task ? item.task : lockupLabel(item[field], tasks)}</td>
                        ) : field === 'phaseCode' ? (
                          <td>{lockupLabel(item[field], phases)}</td>
                        ) : (
                          <td>{item[field]}</td>
                        ),
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </View>
          </TableCell>
        </TableRow>,
      );
    }
  }
  return res;
};
